export enum StorageEnum {
  PREFIX = 'inside_hub_app',
  USER = 'user-v2', // '-v2' will be removed after all modules are updated
  CURRENT_PARTNER = 'current-partner'
}
